
import { types, actions } from './requests'
export const GETLABELLIST_TYPES = {
    ...types('GETLABELLIST'),
}
export const GETLABELLIST_ACTIONS = {
    ...actions('GETLABELLIST'),
}